import React from 'react';
import {Table} from "antd";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import Constants from "../../../services/Constants";
import moment from 'moment';
import LoadingIndicator from "../../common/loading/LoadingIndicator";

import "./DailyPlanning.css"
import InterventionDate from "../../common/format/InterventionDate";
import InterventionCustomer from "../../common/format/InterventionCustomer";
import InterventionVehicle from "../../common/format/InterventionVehicle";
import SADatePicker from "../../common/input/SADatePicker";

const Column = Table.Column;

class DailyPlanning extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      interventions: {},
      selectedDay: moment().format(Constants.DATE_FORMAT_API)
    }
  }

  componentDidMount() {
    this.loadData(this.state.selectedDay);
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.fetchInterventions && nextProps.fetchInterventions.interventions) {
      this.setState({interventions: nextProps.fetchInterventions.interventions});
    }
  };

  loadData = (day) => {
    const filters = [];
    filters['interventionStart'] = [day];
    filters['status'] = ['CONFIRMED'];
    this.props.dispatchFetchInterventions({}, filters);
  };

  onPrint = () => {
    window.print();
  };

  onDayChange = (day) => {
    const selectedDay = (day) ? moment(day).format(Constants.DATE_FORMAT_API) : moment().format(Constants.DATE_FORMAT_API);

    if (selectedDay !== this.state.selectedDay) {
      this.loadData(selectedDay);
    }
    this.setState({selectedDay});
  };

  isWaiting = (journeyProperties = {}) => {
    const mobility = journeyProperties.mobility || {};
    return mobility.mobility && mobility.mobility.name === 'wait';
  };

  render() {
    const {intl:{formatMessage}, fetchInterventions} = this.props;
    const interventions = fetchInterventions.interventions || {};

    return (
      <section className="box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id:'section.daily-planning.title'})}
          </h2>
          <div className="box-heading__right">
            <button onClick={this.onPrint} type="primary" className="btn btn-sm btn-primary right print-btn">{formatMessage({id:'action.print'})}</button>
          </div>
        </header>
          <div className="box__body">
            <div className="table-wrapper__header">
              <SADatePicker onChange={this.onDayChange} value={moment(this.state.selectedDay)}/>
            </div>
            {
              (fetchInterventions.loading) ? (
                <LoadingIndicator/>
              ) : (
                <div className="table-wrapper__body">
                  <Table className="table overview-table"
                         dataSource={interventions.content}
                         loading={fetchInterventions.loading}
                         rowKey={'carVin'}
                         pagination={false}
                  >
                    <Column
                      title={formatMessage({id:'tasksTable.dates'})}
                      dataIndex="interventionDate"
                      key="dates"
                      className="overview-table__dates"
                      render={(text, record) => (
                        <InterventionDate interventionStart={record.interventionStart} interventionEnd={record.interventionEnd} properties={record.properties}/>
                    )}
                    />
                    <Column
                      title={formatMessage({id:'tasksTable.customerCar'})}
                      dataIndex="customerCar"
                      key="customerCar"
                      className="overview-table__customer-car"
                      render={(text, record) => (
                        <InterventionCustomer firstName={record.customerFirstname} lastName={record.customerLastname} carBrand={record.carBrand} carModel={record.carModel}/>
                      )}
                    />
                    <Column
                      title={formatMessage({id:'vehicle.vin'}) + ' & ' + formatMessage({id:'vehicle.plate'})}
                      dataIndex="vinPlate"
                      key="vinPlate"
                      className="overview-table__vin-plate"
                      render={(text, record) => (
                        <InterventionVehicle carVin={record.carVin} carPlate={record.carPlate}/>
                      )}
                    />
                    <Column
                      title={formatMessage({id:'tasksTable.waiting'})}
                      className="overview-table__waiting"
                      dataIndex="properties"
                      key="properties"
                      render={text => {
                        const isWaiting = this.isWaiting(text) ? Constants.CHOICE_YES : Constants.CHOICE_NO;
                        return (
                          <span className="table-status">{formatMessage(isWaiting)}</span>
                        )
                      }}
                    />
                  </Table>
                </div>
              )
            }
          </div>
      </section>
    )
  }
}

const mapStateToProps = state => ({
  fetchInterventions: state.fetchInterventions,
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchInterventions: (parameters, filters) => dispatch({type: 'FETCH_INTERVENTIONS_OVERVIEW.REQUEST', parameters, filters})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(DailyPlanning));



// WEBPACK FOOTER //
// ./src/components/planning/overview/DailyPlanning.js